import { jobChangeTagLabelParser } from '../components/filter-tags/utils';
import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';

export default function jobChangeFilterConfig(): SearchFilterBase {
  return {
    name: 'Saved Contact Updates',
    icon: 'job-change',
    index: 15,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.CONTACT_DATA],
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Job Change',
        },
      },
    },
    pinned: true,
    layer: 3,
    items: [
      {
        type: SearchFilterType.RADIO,
        icon: undefined,
        index: 0,
        field: 'contact_job_change',
        key: 'contact_job_change',
        name: '',
        layer: 4,
        metadata: {
          color: 'primary',
          skipUrlParams: true,
          styles: {
            sx: {
              paddingLeft: 1,
            },
          },
        },
        utils: { tags: { labelFormatter: jobChangeTagLabelParser } },
        options: [
          {
            type: 'STRING',
            value: 'true',
            label: 'Contact with job changes',
            icon: null,
            index: 1,
          },
          {
            type: 'STRING',
            value: 'false',
            label: 'Contact without job changes',
            icon: null,
            index: 2,
          },
        ],
      },
    ],
  };
}
